import React from 'react'
import { Button, DialogActions } from '@mui/material'

import { REFUND_APPROVAL_TEXT } from '../../../constants/refundApprovalText'
import {
  UI_COLOR_BORDER_CANCEL,
  UI_COLOR_PRIMARY_ALT,
  UI_COLOR_PRIMARY_SOFT_ALT
} from '../../../../constants/uiColors'

const footerButtonBaseSx = {
  width: { xs: 'calc(50% - 4px)', sm: 'auto' },
  height: 40,
  minHeight: 40,
  px: { xs: 0.5, sm: 2 },
  py: 0,
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: { xs: 10.5, sm: 13 },
  fontWeight: 800,
  lineHeight: 1.2,
  textAlign: 'center',
  whiteSpace: { xs: 'normal', sm: 'nowrap' },
  m: 0
}

const RefundScanModalFooter = ({ canSave, saveButtonLabel, onClose, onSave }) => (
  <DialogActions
    disableSpacing
    sx={{
      justifyContent: { xs: 'space-between', sm: 'flex-end' },
      alignItems: 'center',
      gap: { xs: 1, sm: 1.5 },
      px: 3,
      pb: { xs: 1.25, sm: 1 },
      flexWrap: { xs: 'nowrap', sm: 'wrap' }
    }}
  >
    <Button
      variant="outlined"
      onClick={onClose}
      sx={{
        ...footerButtonBaseSx,
        minWidth: { xs: 0, sm: 158 },
        border: `1px solid ${UI_COLOR_BORDER_CANCEL}`,
        color: UI_COLOR_BORDER_CANCEL
      }}
    >
      {REFUND_APPROVAL_TEXT.backToDetail}
    </Button>
    <Button
      variant="contained"
      onClick={onSave}
      disabled={!canSave}
      disableElevation
      sx={{
        ...footerButtonBaseSx,
        minWidth: { xs: 0, sm: 180 },
        border: '1px solid transparent',
        backgroundColor: UI_COLOR_PRIMARY_SOFT_ALT,
        '&:hover': { backgroundColor: UI_COLOR_PRIMARY_ALT }
      }}
    >
      {saveButtonLabel}
    </Button>
  </DialogActions>
)

export default RefundScanModalFooter
